import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { changeDeliveryType } from "@redux"
import CheckoutTableNumber from "./CheckoutTableNumber"
import CheckoutDelivery from "./CheckoutDelivery"
import classes from "./CheckoutDeilveryType.module.scss"

const CheckoutDeilveryType = props => {
  const {
    note,
    discounts,
    cashTypes,
    isLinkPay,
    isGuestOrder,
    orderHasSplited,
    isOrderEditable,
    focusedCashType,
    multiplePayment,
    printCustomerReceipt,
    sendPrintCustomerReceiptToPos,
    selectedUserAccount
  } = props

  const [t] = useTranslation()

  const dispatch = useDispatch()

  const deliveryType =
    useSelector(state =>
      state.deliveryInfo.deliveryType
    )

  const { deliveryTypeOptions, serviceTypeName } =
    useSelector(state => state.systemSettings)

  const handleClick = deliveryType => {
    dispatch(changeDeliveryType(deliveryType))
  }

  const showDeliveryOption =
    deliveryTypeOptions.delivery

  const showCinemaOption =
    deliveryTypeOptions.cinema

  const showDineInOption =
    serviceTypeName === "restaurant"

  const disabled =
    orderHasSplited ||
    !isOrderEditable

  return (
    <div className={classes["container"]}>
      <div className={classes["row"]}>
        {
          showDineInOption &&
          <button
            disabled={disabled}
            onClick={() => handleClick("dineIn")}
            className={clsx(
              classes["deliveryType"],
              disabled && classes["disabled"],
              deliveryType === "dineIn" && classes["active"]
            )}
          >
            {t("سالن")}
          </button>
        }

        <button
          disabled={disabled}
          onClick={() => handleClick("selfPickup")}
          className={clsx(
            classes["deliveryType"],
            classes["padding"],
            deliveryType === "selfPickup" && classes["active"],
            disabled && classes["disabled"]
          )}
        >
          {t("بیرون_بر")}
        </button>

        {
          showDeliveryOption &&
          <button
            disabled={disabled}
            onClick={() => handleClick("delivery")}
            className={clsx(
              classes["deliveryType"],
              disabled && classes["disabled"],
              deliveryType === "delivery" && classes["active"]
            )}
          >
            {t("ارسال")}
          </button>
        }

        {
          showCinemaOption &&
          <button
            disabled={disabled}
            onClick={() => handleClick("cinema")}
            className={clsx(
              classes["deliveryType"],
              disabled && classes["disabled"],
              deliveryType === "cinema" && classes["active"]
            )}
          >
            {t("سینما")}
          </button>
        }
      </div >
      {
        deliveryType === "dineIn" &&
        <CheckoutTableNumber
          disabled={disabled}

          note={note}
          discounts={discounts}
          cashTypes={cashTypes}
          isLinkPay={isLinkPay}
          multiplePayment={multiplePayment}
          focusedCashType={focusedCashType}
          printCustomerReceipt={printCustomerReceipt}
          selectedUserAccount={selectedUserAccount}
          sendPrintCustomerReceiptToPos={sendPrintCustomerReceiptToPos}
        />
      }
      {
        deliveryType === "delivery" &&
        <CheckoutDelivery
          isGuestOrder={isGuestOrder}
          selectedUserAccount={selectedUserAccount}
        />
      }
    </div>
  )
}

export default React.memo(CheckoutDeilveryType)